import React, { useEffect, useRef, useState } from "react";
import {
  Bar,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  ComposedChart,
  LabelList,
  Legend,
  Cell,
  ReferenceLine
} from "recharts";
import { PrAnalysisApi } from "../../../../../../api/Api";
import { FaCrosshairs } from 'react-icons/fa';
import { AuthenticationContext } from "../../../../../../context/AuthenticationContext";

import {
  Box,
  Card,
  CardContent,
  Grid,
  Typography,
  useTheme,
  CardActions,
  Button,
  IconButton
} from "@mui/material";

import RefreshIcon from '@mui/icons-material/Refresh';
import UserAnalyticsTab from "../UserAnalyticsTabs";
import DownloadJpegButton from "../../../../../../components/downloadJpegButton/DownloadJpegButton";


// Function to get default dates
export function getDateTimeForDashboardTab1(date = new Date()) {
  const formattedCurrentDate = date.toISOString().split("T")[0]; // Format: YYYY-MM-DD
  const tenDaysAgo = new Date(date);
  tenDaysAgo.setDate(tenDaysAgo.getDate() - 10);
  const formattedTenDaysAgo = tenDaysAgo.toISOString().split("T")[0]; // Format: YYYY-MM-DD

  return {
    Today: formattedCurrentDate,
    LastDay: formattedTenDaysAgo,
  };
}

const UserAnalyticsTab5 = () => {
  const chartRef = useRef();
  const { LoggedInUserInfo } = React.useContext(AuthenticationContext)
  const [StartDate, setStartDate] = useState(getDateTimeForDashboardTab1().LastDay);
  const [EndDate, setEndDate] = useState(getDateTimeForDashboardTab1().Today);
  const [chartData3, setChartData3] = useState([]);
  const theme = useTheme();
  const { palette, spacing, shape: { borderRadius } } = useTheme()
  const [idealValue, setIdealValue] = useState(5); // Default value, editable


  const credentials = {
    USER: localStorage.getItem("LoginID") || "",
    LCODE: localStorage.getItem("LCODE") || "",
    PASS_KEY: localStorage.getItem("PASS_KEY") || "XYZ",
    WEB_KEY: localStorage.getItem("WEB_KEY") || "WEBXYZ321",
    DT1: StartDate, // Default Start Date
    DT2: EndDate, // Default End Date
  };

  // Fetch data from the API
  const fetchLogData = async () => {
    try {
      const res = await PrAnalysisApi(credentials);

      if (res?.data && Array.isArray(res.data)) {
        // console.log("Fetched Data:", res.data);

      // Transform the API data of chart3
       const transformedData3 = res.data.map((item) => ({
          name: item.DATET || "N/A", // Use `DATET` for labels on X-axis
          ENG: parseFloat(item.ENG) || 0, // Specific_Yield value
          Specific_Yield: parseFloat(item.Specific_Yield) || 0, // Specific_Yield value
        }));

        setChartData3(transformedData3);
 } else {

        setChartData3([]); // Handle invalid data response

      }
    } catch (err) {
      console.error("Error fetching data:", err);
    }
  };



  useEffect(() => {
    fetchLogData();
  }, []);

  // Handle Start Date change
  const handleStartDateChange = (value) => {
    setStartDate(value); // Update the StartDate directly
  };

  // Handle End Date change
  const handleEndDateChange = (value) => {
    setEndDate(value); // Update the EndDate directly
  };


  // Refresh data only when clicking "Show"
  function onRefreshData() {
    if (StartDate.length !== 0 && EndDate.length !== 0) {
      fetchLogData(); // Fetch data only after clicking the button
    } else {
      alert("Please Specific_Yieldovide valid dates");
    }
  }

  return (

    <>
      <Box bgcolor={""} py={2}>

        <Grid container spacing={spacing(1)} flexGrow={1} sx={{ mt: 1 }}>
          <Grid key="chart-grid" item xs={12}>
            <Card>
              <CardActions sx={{
                display: "flex", // Enable flexbox
                justifyContent: "flex-end", // Align items to the right
                alignItems: "center", // Center items vertically
                gap: "16px", // Add some spacing between the inputs
              }}>
                <label>
                  From:&nbsp;
                  <input
                    type="date"
                    value={StartDate} // Use StartDate directly
                    onChange={(e) => handleStartDateChange(e.target.value)}
                    style={{
                      padding: "2px 2px",
                      borderRadius: "14px",
                      border: "1px solid #ccc",
                    }}
                  />
                </label>
                <label>
                  To:&nbsp;
                  <input
                    type="date"
                    value={EndDate} // Use EndDate directly
                    onChange={(e) => handleEndDateChange(e.target.value)}
                    style={{
                      padding: "2px 2px",
                      borderRadius: "14px",
                      border: "1px solid #ccc",
                    }}
                  />
                </label>
                {/* <Button onClick={onRefreshData} variant='contained' sx={{ color: 'white', p: 0, m: 0, fontSize: '12px', backgroundColor: palette.tintBlue, borderRadius: borderRadius }}>Show</Button> */}
                <IconButton
                  onClick={onRefreshData}
                  sx={{
                    color: 'black',
                    // backgroundColor: palette.tintBlue,
                    borderRadius: borderRadius,
                    p: 1, // Adjust padding if needed
                  }}
                >
                  <RefreshIcon sx={{ fontSize: '24px' }} />
                </IconButton>
                <DownloadJpegButton targetRef={chartRef} fileName={`Specific Yield Comparison.jpeg`} />
              </CardActions>
            </Card>
          </Grid>


        </Grid>




        <Grid container spacing={2} flexGrow={1} sx={{ mt: 1 }}>



          {/* Specific_Yield Curve Section */}
          <Grid ref={chartRef}  item xs={12} md={12}>
            <Card>
              <Box
                sx={{
                  padding: "4px",
                  borderRadius: "5px",
                  marginBottom: "15px",
                  textAlign: "start",
                  fontWeight: "bold",
                  fontSize: "16px",
                  border: "1px solid lightgray",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <FaCrosshairs style={{ marginRight: '10px', color: 'black' }} />
                Specific_Yield Comparison
                <Box sx={{ marginLeft: "auto", display: "flex", alignItems: "center" }}>
                  <label style={{ fontSize: 14, fontWeight: 500, marginRight: 6 }}>
                    Ideal Value:&nbsp;
                    <input
                      type="number"
                      value={idealValue}
                      onChange={e => setIdealValue(Number(e.target.value))}
                      style={{
                        width: '60px',
                        padding: "2px 2px",
                        borderRadius: "10px",
                        border: "1px solid #ccc",
                      }}
                    />
                  </label>
                </Box>
              </Box>

              <CardContent sx={{ padding: "2px" }}>
                {
                  chartData3.length > 0 ? (
                    <ResponsiveContainer width="100%" height={400}>
                      <ComposedChart
                        data={chartData3.map(item => ({
                          ...item,
                          Specific_YieldBarColor: item.Specific_Yield >= idealValue ? "#39e524" : "#ff1d1d"
                        }))}
                        margin={{ top: 10, right: 10, left: 10, bottom: 5 }}
                      >
                        <CartesianGrid strokeDasharray="3 3" />
                        <XAxis dataKey="name" />
                        <YAxis
                          yAxisId="right"
                          orientation="right"
                          label={{
                            value: "Specific_Yield",
                            angle: 90,
                            position: "insideRight",
                          }}
                        />
                        <Tooltip />
                        <Legend
                          layout="horizontal"
                          verticalAlign="top"
                          align="center"
                          wrapperStyle={{
                            paddingBottom: "10px",
                            fontSize: "12px",
                          }}
                        />

                        {/* ✅ Ideal Line */}
                        <ReferenceLine
                          y={idealValue}
                          yAxisId="right"
                          stroke="red"
                          strokeDasharray="4 4"
                          strokeWidth={3}
                        // label={{
                        //   value: `Ideal (${idealValue})`,
                        //   position: "top",
                        //   fill: "red",
                        //   fontSize: 15,
                        //   fontWeight: "bold"
                        // }}
                        />


                        {/* Specific_Yield Bars */}
                        <Bar
                          dataKey="Specific_Yield"
                          name="Specific_Yield"
                          yAxisId="right"
                          isAnimationActive={false}
                        >
                          <LabelList
                            dataKey="Specific_Yield"
                            position="top"
                            style={{
                              fontSize: "12px",
                              fontWeight: "bold"
                            }}
                          />
                          {chartData3.map((item, index) => (
                            <Cell key={`cell-${index}`}
                              fill={item.Specific_Yield >= idealValue ? "#39e524" : "#ff1d1d"}
                            />
                          ))}
                        </Bar>
                      </ComposedChart>
                    </ResponsiveContainer>
                  ) : (
                    <Typography
                      variant="body1"
                      color="textSecondary"
                      textAlign="center"
                    >
                      No data available for the selected range.
                    </Typography>
                  )
                }
              </CardContent>
            </Card>

          </Grid>

        </Grid>


      </Box>


    </>

  );
};

export default UserAnalyticsTab5;

